<template>
  <div class="page-class page-user-list">
    <h1 class="page-title">{{ title }}</h1>
    <table-box-order
      :columns="columns"
      :rows="banners"
      :baseUrl="baseUrl"
      :loading="loading"
      :showAdd="true"
      :showDownload="false"
      :showUpload="false"
      :showToolbar="true"
      :showPagination="true"
      :pagination="pagination"
      :filterOptions="filterOptions"
      :searchItems="searchItems"
      addText="Create new Banner"
      downloadText="Download Banners List"
      uploadText="Upload Banners List"
      emptyText="No Data found."
      @add="onAdd"
      @edit="onEdit"
      @delete="onDelete"
      @show-upload="onShowUpload"
    >
      <template v-slot:emailAddressFormatted="slotProps">
        <span class="span-text span-block">
          {{ slotProps.row.email }}
        </span>
        <template v-if="slotProps.row.confirmedAtFormatted">
          <span class="text-success span-help-text" :title="slotProps.row.confirmedAt">
            ({{ slotProps.row.confirmedAtFormatted }})
          </span>
        </template>
        <template v-if="slotProps.row.confirmedAtFormatted === null">
          <span class="text-warning span-help-text"> (Not confirmed) </span>
        </template>
      </template>
      <template v-slot:lastLoginAtFormatted="slotProps">
        <template v-if="slotProps.row.lastLoginAtFormatted">
          <span class="text-success">{{ slotProps.row.lastLoginAtFormatted }}</span>
        </template>
        <template v-if="slotProps.row.lastLoginAtFormatted == null">
          <span class="text-warning">Never logged in</span>
        </template>
      </template>
      <template v-slot:blockedAtFormatted="slotProps">
        <template v-if="slotProps.row.blockedAtFormatted">
          <span class="text-success">{{ slotProps.row.blockedAtFormatted }}</span>
        </template>
        <template v-if="slotProps.row.blockedAtFormatted == null">
          <span class="text-warning">Never logged in</span>
        </template>
      </template>
    </table-box-order>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import TableBoxOrder from '../../components/TableBoxOrder.vue';

export default {
  name: 'BannerList',
  components: {
    TableBoxOrder
  },
  metaInfo() {
    return {
      title: 'Banners List',
      meta: [
        {
          name: 'description',
          content: `Manage banners list.`
        }
      ]
    };
  },
  mounted() {
    this.listBanner({ query: this.$route.query });
  },
  beforeRouteUpdate(to, from, next) {
    this.listBanner({ query: to.query });
    next();
  },
  data() {
    return {
      title: 'Banners List',
      columns: [
        {
          type: 'row_num',
          headerText: '#',
          class: { 'text-center': true },
          textKey: 'rowNum',
          width: '5%'
        },
        {
          type: 'string',
          headerText: 'Title',
          class: { 'text-center': true },
          textKey: 'title',
          width: '15%'
        },
        {
          type: 'string',
          headerText: 'Active',
          class: { 'text-center': true },
          textKey: 'active',
          width: '7%'
        },
        {
          type: 'string',
          headerText: 'StartDate',
          class: { 'text-center': true },
          textKey: 'startDate',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'EndDate',
          class: { 'text-center': true },
          textKey: 'endDate',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'Store Ids',
          class: { 'text-center': true },
          textKey: 'storeids',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'Regions',
          class: { 'text-center': true },
          textKey: 'regions',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'Clusters',
          class: { 'text-center': true },
          textKey: 'clusters',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'Formats',
          class: { 'text-center': true },
          htmlKey: 'formats',
          width: '10%'
        },
        {
          type: 'functions',
          headerText: 'Functions',
          class: { 'text-center': true },
          width: '13%',
          functions: {
            edit: true,
            delete: true,
            ack: false
          }
        }
      ],
      searchItems: ['Title', 'Store Id'],
      filterOptions: [
        { value: null, text: 'Select Filter' },
        { value: 'Active-True', text: 'Active-True' },
        { value: 'Active-False', text: 'Active-False' }
      ]
    };
  },
  computed: {
    ...mapState('catalogueBanner', ['loading', 'baseUrl', 'banners', 'pagination']),
    ...mapState('darkMode',['isDarkMode'])
  },
  methods: {
    ...mapActions('catalogueBanner', ['listBanner', 'deleteOne']),
    onAdd() {
      this.$router.push(`/productBanner/new`);
    },
    onEdit({ row }) {
      this.$router.push(`/productBanner/${row.id}`);
    },
    async onShowUpload() {
      const footer =
        '<a href="https://spencer-template.s3.ap-south-1.amazonaws.com/Orders.csv" >Download sample upload file</a>';
      const { value: orderFile } = await Vue.swal({
        title: 'Upload file for orders..',
        input: 'file',
        inputAttributes: {
          'aria-label': 'Upload your orders file in csv format'
        },
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Upload',
        showCancelButton: true,
        cancelButtonText: 'Close',
        footer,
           background: this.isDarkMode ? '#1e1e1e' : '#fff',
    color: this.isDarkMode ? '#fff' : '#000',
    customClass: {
      popup: this.isDarkMode ? 'swal-dark-mode' : ''
    }
      });
      if (orderFile) {
        const reader = new FileReader();
        reader.readAsText(orderFile);
        reader.onload = e => {
          this.upload({ data: e.target.result, router: this.$router });
        };
      }
    },
    onDelete({ row }) {
      Vue.swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this.",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',

        preConfirm: () => {
          this.deleteOne({
            id: row.id,
            sort: true
          });
        }
      });
    }
  }
};
</script>
